import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./state/store/store";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Authentication from "./Authentication";
import 'typeface-roboto'
// import TwitterWidgetsLoader from 'twitter-widgets';
import {createTheme} from "@mui/material/styles";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import ErrorBoundary from "./components/util/common/ErrorBoundary";
import {lighten} from '@mui/material/styles'

const theme = createTheme({
  palette: {
    common: { black: '#000', white: '#fff' },
    background: { paper: '#fff', default: '#fafafa' },
    primary: {
      contrastText: '#fff',
      // dark: 'rgba(0, 47, 67, 1)',
      main: 'rgba(38, 126, 166, 1)',
      // light: 'rgba(77, 149, 182, 1)',
      primary: 'rgba(0, 0, 0, 0.87)',
    },
    secondary: {
      contrastText: '#fff',
      main: 'rgba(239, 131, 84, 1)',
      light: 'rgba(241, 153, 115, 1)',
      // dark: 'rgba(196, 108, 69, 1)',
    },
    error: {
      // light: '#e57373',
      main: '#f44336',
      // dark: '#d32f2f',
      contrastText: '#fff',
    },
    info: {
      main: '#0288d1',
      contrastText: '#fff',
    },
    success: {
      main: '#2e7d32',
      contrastText: '#fff',
    },
    warning: {
      main: '#ed6c02',
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
    },
  },
  
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // color: 'rgba(0, 0, 0, 0.87)',
          // borderColor: 'rgba(0, 0, 0, 0.23)',
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          minWidth: 'unset'
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '3px'
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          lineHeight: 1
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: "9px 12px 6px",
          lineHeight: 1.75,
        },
        textColorInherit: {
          opacity: 0.7
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-selected': {
            backgroundColor: lighten(theme.palette.secondary.light, 0.92),
            '&:hover': {
              backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            },
          },
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-checked': {
            color: theme.palette.secondary.main,
          },
        }),
      },
    },
  //   MuiTooltip: {
  //     styleOverrides: {
  //       tooltip: {
  //         fontSize: '0.85em',
  //       },
  //     },
  //   },
  //   MuiInputLabel: {
  //     styleOverrides: {
  //       outlined: {
  //         transform: 'translate(14px, 12px) scale(1)',
  //       },
  //     },
  //   },
  },
});

ReactDOM.render(
  // Root component needs to be wrapped in <Provider> so the components
  // can access the redux store

      <ErrorBoundary>
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <StylesThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <Authentication />
        </ThemeProvider>
      </StylesThemeProvider>
    </StyledEngineProvider>
  </Provider>
  
      </ErrorBoundary>,
  document.getElementById("root")
);

// Load twitter widget on window.twttr
// TwitterWidgetsLoader.load();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();